import gql from 'graphql-tag';

import { clientWeb } from '../graphqlAPI';

const USER_DELETE_ACCOUNT = gql`
  mutation Post($email: String!) {
    userDeleteAccount(
      email: $email,
      ){
        email
        isDeleted
        error
    }
}`;

const userDeleteAccount = async ({
  email,
}) => {
  try {
    const result = await clientWeb.mutate({
      mutation: USER_DELETE_ACCOUNT,
      variables: {
        email,
      },
      fetchPolicy: 'no-cache',
    })
      .then(queryResult => queryResult)
      .catch((queryError) => {
        console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: Apollo Client Query Error: ${queryError}`);
        return null;
      });

    const { data: { userDeleteAccount: validatedFormData } } = result;

    if (validatedFormData) {
      return validatedFormData;
    }
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: GraphQL Query Error: validatedFormData = null`);
    return null;
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: userDeleteAccount Error: ${error}`);
    return null;
  }
};

export default userDeleteAccount;
